/** No Workbox update/reload listeners: the retirement worker owns its one-time cleanup. */
export function registerRetirementWorker() {
  if (!("serviceWorker" in navigator)) return;
  const register = () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/", updateViaCache: "none" })
      .catch((error) => console.warn("Could not retire the old app worker:", error));
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
